var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "300" },
      model: {
        value: _vm.loading,
        callback: function($$v) {
          _vm.loading = $$v
        },
        expression: "loading"
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "primary" } },
        [
          _c(
            "v-card-text",
            { staticClass: "background--text" },
            [
              _vm._v("\n\t\t\tChargement...\n\t\t\t"),
              _c("v-progress-linear", {
                staticClass: "mb-0",
                attrs: { indeterminate: "", color: "background" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2448eba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2448eba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/loader.vue
// module id = null
// module chunks = 